import React from 'react';
interface Props {
  fillColor?: string;
}
function BloodIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none">
      <g clipPath="url(#clip0_851_3290)">
        <path
          d="M6 14.5C3.51562 14.5 1.5 12.4844 1.5 10C1.5 9.59375 1.65937 8.95312 2.03125 8.09062C2.39062 7.25937 2.89375 6.34687 3.45312 5.44375C4.35938 3.98125 5.35938 2.625 6 1.7875C6.64062 2.62188 7.64375 3.98125 8.54688 5.44375C9.10625 6.34687 9.60938 7.25625 9.96875 8.09062C10.3406 8.95312 10.5 9.59688 10.5 10C10.5 12.4844 8.48438 14.5 6 14.5ZM0 10C0 13.3125 2.6875 16 6 16C9.3125 16 12 13.3125 12 10C12 7.15 7.93125 1.80313 6.79375 0.365625C6.60625 0.13125 6.32812 0 6.02812 0H5.97188C5.67188 0 5.39375 0.13125 5.20625 0.365625C4.06875 1.80313 0 7.15 0 10ZM4.5 9.75C4.5 9.33438 4.16563 9 3.75 9C3.33437 9 3 9.33438 3 9.75C3 11.5437 4.45625 13 6.25 13C6.66563 13 7 12.6656 7 12.25C7 11.8344 6.66563 11.5 6.25 11.5C5.28438 11.5 4.5 10.7156 4.5 9.75Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3290">
          <rect width="12" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BloodIcon;
